





















































































import { Component, Prop, Watch } from 'vue-property-decorator';
import { ToastProgrammatic as Toast } from 'buefy';
import { Action, State } from 'vuex-class';
import {
  GripStrategy,
  GripStrategyDTO,
  UpdateGripStrategyBase,
  UpdateGripStrategyPayload,
} from '../../../store/types/grip.types';
import { ApiState } from '../../../store/types/general.types';
import StrategyModal from './StrategyModal.vue';
import BasePagination from '../../../components/base/BasePagination.vue';
import DeleteModalBox from '../../../components/DeleteModalBox.vue';
import { isTruthy } from '../../../jbi-shared/util/watcher.vue-decorator';
import { PaginationMixin } from '../../../components/base/pagination.mixin';
import { mixins } from 'vue-class-component';
import { getUpperCase } from '../../../utils/general.util';

@Component({
  components: { BasePagination, StrategyModal, DeleteModalBox },
})
export default class StrategyList extends mixins(PaginationMixin) {
  @Prop() public items!: GripStrategy[];
  @Prop(Number) public totalNumberOfPage!: number;
  @Prop(Number) public totalCount!: number;
  @Prop(Boolean) public isFirstPage!: boolean;
  @Prop(Boolean) public isLastPage!: boolean;
  @Prop(Number) public startItemIndex!: number;
  @Prop(Number) public endItemIndex!: number;

  @Prop({ type: Number, default: null }) public editingStrategyId!:
    | number
    | null;
  @Prop({ type: Boolean, default: false }) public isMinimized!: boolean;

  get projectId(): number {
    return +this.$route.params.projectId;
  }

  public getUpperCase(value: string) {
    return getUpperCase(value);
  }

  public handleEdit(strategy: GripStrategy): void {
    this.$emit('edit-strategy', strategy);
  }
}
